import { FC } from 'react';
import { Section } from './ui/Section';
import type { Reference } from '../types/cv';

interface Props {
  references: Reference[];
  title?: string;
}

export const References: FC<Props> = ({ references, title = 'References' }) => (
  <Section title={title}>
    {references.map((ref, i) => (
      <div className="cv-entry" key={`${ref.name}-${i}`}>
        {ref.reference && <blockquote className="cv-quote">{ref.reference}</blockquote>}
        {ref.name && <p className="cv-quote-name">— {ref.name}</p>}
      </div>
    ))}
  </Section>
);

export default References;
